import React from "react";
import {
  Avatar,
  Badge,
  Button,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { navbarActionStyle } from "./navbarVisualOwnership";

function actionSx(style, compact) {
  return {
    width: compact ? { xs: 38, sm: 42 } : 44,
    height: compact ? { xs: 38, sm: 42 } : 44,
    color: style.color,
    bgcolor: style.backgroundColor,
    border: "1px solid",
    borderColor: style.borderColor,
    boxShadow: compact ? "none" : "0 5px 16px rgba(20,25,35,.06)",
    "&:hover": {
      color: style.hoverColor,
      bgcolor: style.hoverBackgroundColor,
      borderColor: style.hoverBorderColor,
    },
  };
}

export default function NavbarActions({
  user,
  navigation,
  ordersEnabled,
  cartCount,
  onOpenCart,
  onOpenAccount,
  onLogin,
  compact = false,
}) {
  const showAccess = navigation?.showCustomerAccess !== false;
  const loginLabel = String(navigation?.loginLabel ?? "").trim();
  const showCart = ordersEnabled && navigation?.showCart !== false;
  const device = compact ? "mobile" : "desktop";
  const loginStyle = navbarActionStyle(navigation, "login", device);
  const accountStyle = navbarActionStyle(navigation, "account", device);
  const cartStyle = navbarActionStyle(navigation, "cart", device);

  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      {showAccess ? (
        user ? (
          <Tooltip title={navigation?.accountLabel ?? "Mi cuenta"}>
            <IconButton
              onClick={onOpenAccount}
              aria-label={navigation?.accountLabel ?? "Mi cuenta"}
              sx={actionSx(accountStyle, compact)}
            >
              <Avatar
                sx={{
                  width: 31,
                  height: 31,
                  bgcolor: accountStyle.avatarBackgroundColor,
                  color: accountStyle.avatarTextColor,
                  fontSize: ".86rem",
                  fontWeight: 900,
                }}
              >
                {String(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
              </Avatar>
            </IconButton>
          </Tooltip>
        ) : compact && loginLabel ? (
          <Tooltip title={loginLabel}>
            <IconButton
              onClick={onLogin}
              aria-label={loginLabel}
              sx={actionSx(loginStyle, true)}
            >
              <PersonOutlineRoundedIcon />
            </IconButton>
          </Tooltip>
        ) : loginLabel ? (
          <Button
            data-landing-field="navigation.loginLabel"
            onClick={onLogin}
            sx={{
              minHeight: 42,
              px: 1.7,
              borderRadius: 999,
              color: loginStyle.color,
              bgcolor: loginStyle.backgroundColor,
              border: "1px solid",
              borderColor: loginStyle.borderColor,
              fontWeight: 800,
              whiteSpace: "nowrap",
              "&:hover": {
                color: loginStyle.hoverColor,
                bgcolor: loginStyle.hoverBackgroundColor,
                borderColor: loginStyle.hoverBorderColor,
              },
            }}
          >
            {loginLabel}
          </Button>
        ) : null
      ) : null}

      {showCart ? (
        <Tooltip title={navigation?.cartTooltip ?? "Carrito"}>
          <IconButton
            onClick={onOpenCart}
            aria-label={`${navigation?.cartAriaLabel ?? "Abrir carrito"}: ${cartCount}`}
            sx={actionSx(cartStyle, compact)}
          >
            <Badge
              badgeContent={cartCount}
              max={99}
              sx={{
                "& .MuiBadge-badge": {
                  minWidth: 18,
                  height: 18,
                  px: 0.45,
                  fontSize: ".68rem",
                  fontWeight: 900,
                  bgcolor: cartStyle.badgeBackgroundColor,
                  color: cartStyle.badgeTextColor,
                },
              }}
            >
              <ShoppingCartOutlinedIcon sx={{ fontSize: 22 }} />
            </Badge>
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
